import { Skeleton, Tooltip, Typography } from '@mui/material';
import { CommonCellProps } from './cells.props';

// Helper function to truncate text
const truncateText = (text: string | null, maxLength: number = 70): string => {
  if (!text || text === '-') {
    return text || '-';
  }
  if (text.length <= maxLength) {
    return text;
  }
  return `${text.substring(0, maxLength).trim()}...`;
};

const NotesCell = ({ valuationRow }: CommonCellProps) => {
  if (valuationRow.is_loading_additional_data) {
    return <Skeleton variant="text" width="80%" height={20} />;
  }

  // Use only the new note structure
  const noteContent = valuationRow.note?.content || '-';
  const hasNotes = noteContent && noteContent !== '-' && noteContent !== 'null' && noteContent !== 'undefined';
  const truncatedText = truncateText(noteContent);
  const isTruncated = hasNotes && noteContent.length > 70;
  
  if (isTruncated) {
    return (
      <Tooltip title={noteContent} placement="top" arrow>
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'text.primary',
            fontStyle: 'normal'
          }}
        >
          {truncatedText}
        </Typography>
      </Tooltip>
    );
  }
  
  return (
    <Typography 
      variant="body2" 
      sx={{ 
        color: hasNotes ? 'text.primary' : 'text.secondary',
        fontStyle: hasNotes ? 'normal' : 'italic'
      }}
    >
      {truncatedText}
    </Typography>
  );
};

export default NotesCell;

